import React, { SVGProps } from 'react'

export default function CubeIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" fill="none" {...props}>
      <circle cx={15} cy={15} r={15} fill="currentColor" />
      <path
        fill="currentColor"
        d="M23.71 19.353v-7.742a1.934 1.934 0 0 0-.968-1.674l-6.774-3.871a1.935 1.935 0 0 0-1.936 0l-6.774 3.87a1.935 1.935 0 0 0-.968 1.675v7.742a1.936 1.936 0 0 0 .968 1.674l6.774 3.871a1.935 1.935 0 0 0 1.936 0l6.774-3.87a1.935 1.935 0 0 0 .968-1.675Z"
      />
      <path
        fill="currentColor"
        d="M10.645 7.943 15 10.46l4.355-2.517M10.645 23.02v-5.022L6.29 15.482M23.71 15.482l-4.355 2.516v5.023M6.552 10.605 15 15.492l8.448-4.887"
      />
      <path
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M10.645 7.943 15 10.46l4.355-2.517m-8.71 15.078v-5.023L6.29 15.482m17.42 0-4.355 2.516v5.023M6.552 10.605 15 15.492l8.448-4.887M15 25.237v-9.755m8.71 3.871v-7.742a1.934 1.934 0 0 0-.968-1.674l-6.774-3.871a1.935 1.935 0 0 0-1.936 0l-6.774 3.87a1.935 1.935 0 0 0-.968 1.675v7.742a1.936 1.936 0 0 0 .968 1.674l6.774 3.871a1.935 1.935 0 0 0 1.936 0l6.774-3.87a1.935 1.935 0 0 0 .968-1.675Z"
      />
    </svg>
  )
}
